import { Participant } from "../models/Participant";
import { ParticipantListReportTemplateData } from "./ParticipantListReportTemplateData";
import { ParticipantListReportImportTemplate } from "./ParticipantListReportImportTemplate";
import { cloneDeep } from "lodash";

export const getParticipantListReportTemplate = (
        reportData: Participant[],
    ) => {
    return ParticipantListReportImportTemplate(
        prepareData(reportData)
    );
};

const prepareData = (reportData: Participant[]) => {
    const templateData: ParticipantListReportTemplateData = {//@ts-ignore
        reportData: (cloneDeep(reportData)).sort((a: Participant, b: Participant) => a.createdAt < b.createdAt ? 1 : -1)
    };

    return templateData;
};